/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step3title1Inputs */

const zh_landing_workflow_step3title1 = /** @type {(inputs: Landing_Workflow_Step3title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动跟踪学生进度`)
};

const en_landing_workflow_step3title1 = /** @type {(inputs: Landing_Workflow_Step3title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track student progress automatically`)
};

const es_landing_workflow_step3title1 = /** @type {(inputs: Landing_Workflow_Step3title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue el progreso del alumnado automáticamente`)
};

/**
* | output |
* | --- |
* | "Track student progress automatically" |
*
* @param {Landing_Workflow_Step3title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step3title1 = /** @type {((inputs?: Landing_Workflow_Step3title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step3title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step3title1(inputs)
	if (locale === "en") return en_landing_workflow_step3title1(inputs)
	return es_landing_workflow_step3title1(inputs)
});
export { landing_workflow_step3title1 as "landing_workflow_step3Title" }